
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CardPagination from "@/components/card/CardPagination.vue";

  import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";

  import { Project, User } from "@/generated/graphql";
  import PaginationConfig from "@/entities/PaginationConfig";
  import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ContractorChips from "@/components/companyProjects/ContractorChips.vue";

  import RouteNames from "@/entities/RouteNames";
  import ProjectContractorsCardItem from "@/components/projects/ProjectContractorsCardItem.vue";
  import paginationConfig from "@/data/paginationConfig";
  import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
  import ProjectCollectionManager from "@/components/projects/ProjectCollectionManager.vue";

  interface Conditions {
    offset: number;
    // limit: number;
    where: {
      manager: {
        user: {
          id: {
            _eq: string;
          };
        };
      };
    };
  }

  @Component({
    components: {
      ProjectCollectionManager,
      EmptyListImageProjects,
      CardPagination,
      EmptyListPlaceholder,
      LoadingOverlay,
      CardBodyItem,
      ContractorChips,
      ProjectContractorsCardItem
    },
    apollo: {
      projects: {
        query: LIST_PROJECTS,
        variables() {
          return this.conditions;
        },
        update(data) {
          this.paginationConfig.total = data.total.aggregate.count;
          this.paginationConfig.loadedCount = data.project.length;
          return data.project;
        },
      },
    },
  })
  export default class Projects extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, required: true }) readonly managerFullName!: string;
    @Prop({ type: String, required: true }) readonly managerUserId!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;

    projects?: Project[] = undefined;

    routeNames = RouteNames;

    paginationConfig: PaginationConfig = { ...paginationConfig };

    get offset(): number {
      const { page, limit } = this.paginationConfig;
      return (page - 1) * limit;
    }

    get empty(): boolean {
      if (!this.projects || this.projects.length === 0) {
        return true;
      }

      return false;
    }

    get conditions(): Conditions {
      return {
        offset: this.offset,
        where: {
          manager: {
            user: {
              id: {
                _eq: this.managerUserId,
              },
            },
          },
        },
      };
    }

    get emptyListTitle(): string {
      return ``;
    }

    get emptyListSubtitle(): string {
      return `Start adding clients to ${this.managerFullName}`;
    }

    async handleRefetch(): Promise<void>{
      await this.$apollo.queries.projects.refetch();
      this.$emit('projectNumberChanged', this.paginationConfig.total)
    }
  }
